import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import ServiceERP from './pages/ServiceERP';
import ServiceData from './pages/ServiceData';
import ServiceAgile from './pages/ServiceAgile';
import Experience from './pages/Experience';
import Contact from './pages/Contact';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <LanguageProvider>
      <div className="flex flex-col min-h-screen bg-offwhite text-charcoal antialiased selection:bg-petrol/20 selection:text-petrol">
        {/* Scroll restoration on route change */}
        <ScrollToTop />

        {/* Global Navigation Header */}
        <Header />

        {/* Main Page Content */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-rene" element={<About />} />
            <Route path="/erp-lead" element={<ServiceERP />} />
            <Route path="/data-migration" element={<ServiceData />} />
            <Route path="/agile-scrum-coach" element={<ServiceAgile />} />
            <Route path="/erfaring" element={<Experience />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Global Footer */}
        <Footer />
      </div>
    </LanguageProvider>
  );
}
